module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_OtherAnthologiesTitle"
  }, [_c('span', [_vm._v("Other Anthologies Edited by:")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Patricia Bray & Joshua Palmatier")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("After Hours: Tales from the Ur-bar")])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("The Modern Fae’s Guide to Surviving Humanity")])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Temporally Out of Order  *  Alien Artifacts  *  Were-")])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("All Hail Our Robot Conquerors!")])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Second Round: A Return to the Ur-bar")])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("The Modern Deity’s Guide to Surviving Humanity")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman',serif",
      "font-size": "0.71em"
    }
  }, [_vm._v("Solar Flare")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("S.C. Butler & Joshua Palmatier")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Submerged  *  Guilds & Glaives  *  Apocalyptic")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman',serif",
      "font-size": "0.71em"
    }
  }, [_vm._v("When Worlds Collide  *  Brave New Worlds  *  Dragonesque")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Laura Anne Gilman & Kat Richardson")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("The Death of All Things")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Troy Carrol Bucher & Joshua Palmatier")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("The Razor’s Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Patricia Bray & S.C. Butler")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Portals")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("David B. Coe & Joshua Palmatier")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Temporally Deactivated  *  Galactic Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "'Times New Roman',serif",
      "font-size": "0.71em"
    }
  }, [_vm._v("Derelict")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Steven H Silver & Joshua Palmatier")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Alternate Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Crystal Sarakas & Joshua Palmatier")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("My Battery Is Low and It Is Getting Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("David B. Coe & John Zakour")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Noir")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Crystal Sarakas & Rhondi Salsitz")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Shattering the Glass Slipper")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("David B. Coe & Edmund R. Schubert")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Artifice & Craft")])]), _vm._v(" "), _c('p', {
    staticClass: "P_OtherAnthologiesAuthors"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-family": "'Palatino Linotype',serif",
      "font-size": "0.86em"
    }
  }, [_vm._v("Steven Kotowych & Tony Pi")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span', [_vm._v("Game On!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-355e0080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 63
// module chunks = 0